import { ArrowDownUp, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

// Reusable explicit Sort control (ContentOS Collection Standard). `options` is
// [{ value, label }]; the active option is always visible on the trigger.
export function SortMenu({ options, value, onChange }) {
  const active = options.find((o) => o.value === value) || options[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5" data-testid="collection-sort-trigger">
          <ArrowDownUp className="h-3.5 w-3.5" />
          <span className="hidden sm:inline text-muted-foreground">Sort:</span>
          <span className="max-w-[130px] truncate font-medium">{active?.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {options.map((o) => (
          <DropdownMenuItem key={o.value} onClick={() => onChange(o.value)} data-testid={`collection-sort-${o.value}`}
            className={cn("justify-between", o.value === value && "text-accent")}>
            {o.label}{o.value === value && <Check className="h-3.5 w-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
